import React, { Fragment } from 'react';
import { BrowserRouter, Routes as Switch, Route } from 'react-router-dom';
import Navbar from './layout/Navbar';
import LandingPage from './pages/LandingPage/LandingPage';
// import SignUp from './pages/SignUp/SignUp';
import SignIn from './pages/SignIn/SignIn';
import Footer from './layout/Footer';
import {
  LANDING_ROUTE,
  SIGNIN_ROUTE,
  SIGNUP_ROUTE,
} from './../constants/routesNomenclature';
import { mode } from './../utils/theme';

import Journey from './elems/Journey';
import Letters from './elems/Letters';
import Home from './elems/Home';
import NavbarNew from './elems/NavbarNew';
import FullPageView from './elems/FullPageView';

const Routes = () => {
  return (
    <div style={mode}>
      <BrowserRouter>
        <Fragment>
          <Navbar />
          <div
            style={{
              paddingTop: '55px',
              minWidth: 'fit-content',
              minHeight: '38rem',
            }}
          >
            <NavbarNew/>
            <Switch>
              {/* <PrivateRoute path={EDITPROFILE}>
                <EditProfile />
              </PrivateRoute> */}

              <Route path={LANDING_ROUTE} element={<LandingPage/> } />
                {/* <LandingPage /> */}
              {/* </Route> */}
              <Route path={SIGNIN_ROUTE} element={<SignIn/> } />
                {/* <SignIn /> */}
              {/* </Route> */}
              {/* <Route path={SIGNUP_ROUTE} element={<SignUp/> } /> */}
                {/* <SignUp />  */}
              {/* </Route> */}
              
          <Route path='/home' element={<Home/>} />
          <Route path='/journey' element={<Journey/>} />
          <Route path='/letters' element={<Letters/>} />
          <Route path='/read/:id' element={<FullPageView />} />
            </Switch>
          </div>
          <hr />
          <Footer />
        </Fragment>
      </BrowserRouter>
    </div>
  );
};

export default Routes;
